import React, { useState } from 'react'
import './Todoinput.css'

const Todoinput = (props) => {

    const [inputText,setInputText] = useState('');

    const handleEnterPress = (e) =>{
        if(e.keyCode===13){
            props.addList(inputText)
        setInputText("");
    }
    }

  return (
    <>
    <h1 className='main-heading'>My Task</h1>
    <div className='input-container'>
        <input type='text' className='input-box-todo' placeholder='Create new task...'  value={inputText} onChange={e =>{
            (setInputText(e.target.value))
        }} onKeyDown = {handleEnterPress}/>

        <button className='add-btn' onClick={() =>{
            props.addList(inputText)
            setInputText("");
        }}>+</button>
    </div>
    <h2 className='sub-heading'>This has to be <span>done !!</span></h2>
    </>
  )
}

export default Todoinput
